module.exports = __webpack_public_path__ + "static/img/23.6ecca15f.png";